import React from 'react';
import { Global, css } from '@emotion/react';

import Brandon300 from '../assets/fonts/harrys/Brandon-Light-300.woff';
import Brandon300w2 from '../assets/fonts/harrys/Brandon-Light-300.woff2';
import Brandon400 from '../assets/fonts/harrys/Brandon-Regular-400.woff';
import Brandon400w2 from '../assets/fonts/harrys/Brandon-Regular-400.woff2';
import Brandon500 from '../assets/fonts/harrys/Brandon-Medium-500.woff';
import Brandon500w2 from '../assets/fonts/harrys/Brandon-Medium-500.woff2';
import Brandon700 from '../assets/fonts/harrys/Brandon-Bold-700.woff';
import Brandon700w2 from '../assets/fonts/harrys/Brandon-Bold-700.woff2';

import Museo300 from '../assets/fonts/harrys/Museo-Sans-300.woff';
import Museo300w2 from '../assets/fonts/harrys/Museo-Sans-300.woff2';
import Museo300i from '../assets/fonts/harrys/Museo-Sans-300-Italic.woff';
import Museo300w2i from '../assets/fonts/harrys/Museo-Sans-300-Italic.woff2';
import Museo500 from '../assets/fonts/harrys/Museo-Sans-500.woff';
import Museo500w2 from '../assets/fonts/harrys/Museo-Sans-500.woff2';
import Museo500i from '../assets/fonts/harrys/Museo-Sans-500-Italic.woff';
import Museo500w2i from '../assets/fonts/harrys/Museo-Sans-500-Italic.woff2';
import Museo700 from '../assets/fonts/harrys/Museo-Sans-700.woff';
import Museo700w2 from '../assets/fonts/harrys/Museo-Sans-700.woff2';
import Museo700i from '../assets/fonts/harrys/Museo-Sans-700-Italic.woff';
import Museo700w2i from '../assets/fonts/harrys/Museo-Sans-700-Italic.woff2';

const GlobalStyle = () => {
  const styles = css`
    @font-face {
      font-display: swap;
      font-family: 'Brandon Grotesque';
      src: url(${Brandon700w2}) format('woff2'),
        url(${Brandon700}) format('woff');
      font-style: normal;
      font-weight: 700;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Brandon Grotesque';
      src: url(${Brandon300w2}) format('woff2'),
        url(${Brandon300}) format('woff');
      font-style: normal;
      font-weight: 300;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Brandon Grotesque';
      src: url(${Brandon500w2}) format('woff2'),
        url(${Brandon500}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Brandon Grotesque';
      src: url(${Brandon400w2}) format('woff2'),
        url(${Brandon400}) format('woff');
      font-style: normal;
      font-weight: 400;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo300w2}) format('woff2'), url(${Museo300}) format('woff');
      font-style: normal;
      font-weight: 300;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo300w2i}) format('woff2'), url(${Museo300i}) format('woff');
      font-style: italic;
      font-weight: 300;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo500w2}) format('woff2'), url(${Museo500}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo500w2i}) format('woff2'), url(${Museo500i}) format('woff');
      font-style: italic;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo700w2}) format('woff2'), url(${Museo700}) format('woff');
      font-style: normal;
      font-weight: 700;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Museo Sans';
      src: url(${Museo700w2i}) format('woff2'), url(${Museo700i}) format('woff');
      font-style: italic;
      font-weight: 700;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }
  `;

  return <Global styles={styles} />;
};

export default GlobalStyle;
